export const GET_FILTER_LIST = 'filter/getFilterList';
export const GET_FILTER_LIST_SUCCESS = 'filter/getFilterListSuccess';
